
const gaugeLevelOptions = {
    "height": 10,
    "min": 0,
    "max": 5,
    "tooltip": "false",
    "class": "mx-4 mx-sm-0",
    "style": {
        "padding": "0 8px"
    },
    "bgStyle": {
        "background": "#fff",
        "boxShadow": "inset .5px .5px 3px 1px rgba(0,0,0,.3)"
    },
    "sliderStyle": {
        "backgroundColor": "#AAAAAA",
    },
    "processStyle": {
        "backgroundColor": "#ef0b5c"
    },
    "piecewise": true,
};
export {answerWeightOptions, gaugeLevelOptions};



// WEBPACK FOOTER //
// ./src/components/app/stats-options-slider.js